module.exports = __webpack_public_path__ + "static/img/teamWork.c38d108a.png";